function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1398_2006)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.8455 14C6.96253 14.2027 7.13084 14.371 7.33353 14.488C7.53621 14.605 7.76613 14.6666 8.00016 14.6666C8.2342 14.6666 8.46412 14.605 8.6668 14.488C8.86949 14.371 9.0378 14.2027 9.15483 14M14.6668 5.33331C14.6668 3.79998 14.1335 2.46665 13.3335 1.33331M2.66683 1.33331C1.86683 2.46665 1.3335 3.79998 1.3335 5.33331M2.17483 10.2173C2.08774 10.3128 2.03027 10.4315 2.0094 10.559C1.98853 10.6865 2.00518 10.8173 2.0573 10.9356C2.10943 11.0538 2.19479 11.1544 2.303 11.225C2.41121 11.2956 2.53762 11.3332 2.66683 11.3333H13.3335C13.4627 11.3334 13.5891 11.2959 13.6974 11.2254C13.8057 11.1549 13.8912 11.0545 13.9434 10.9363C13.9957 10.8182 14.0125 10.6874 13.9918 10.5598C13.9711 10.4323 13.9138 10.3135 13.8268 10.218C12.9402 9.30398 12.0002 8.33265 12.0002 5.33331C12.0002 4.27245 11.5787 3.25503 10.8286 2.50489C10.0784 1.75474 9.06103 1.33331 8.00016 1.33331C6.9393 1.33331 5.92188 1.75474 5.17174 2.50489C4.42159 3.25503 4.00016 4.27245 4.00016 5.33331C4.00016 8.33265 3.0595 9.30398 2.17483 10.2173Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1398_2006"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.4c40b2a0.svg";
export { ForwardRef as ReactComponent };